import React from 'react';
import { Checkbox as AntCheckbox } from 'antd';
import cn from 'classnames';
import classes from './Checkbox.module.scss';

const Checkbox = ({
  className,
  radius,
  color,
  blueStyle,
  forceBlue,
  ...other
}) => {
  return (
    <AntCheckbox
      {...other}
      className={cn(
        classes.wrapper,
        {
          [classes.radius]: !!radius,
          [classes.blueStyle]: !!blueStyle,
          [classes.forceBlue]: !!forceBlue,
        },
        classes[color],
        className
      )}
    />
  );
};

export default Checkbox;
